module.exports = __webpack_public_path__ + "static/media/cdb29.1fe535be.png";